import { Button } from "@/components/ui/button";
import { purchaseRestoration } from "@/lib/purchase-restoration";

export function PurchasedIaps({ ids, canRestore, onRestore }: {
  ids: string[]; canRestore: boolean; onRestore: () => void;
}) {
  const { entries } = purchaseRestoration(ids);
  return <div className="rounded-lg border border-border bg-card p-4 space-y-3">
    <div className="flex items-center justify-between gap-3">
      <h3 className="text-sm font-medium">Purchased IAP ({ids.length})</h3>
      <Button variant="secondary" size="sm" disabled={!canRestore || !ids.length} onClick={onRestore}>Restore purchase</Button>
    </div>
    <p className="text-xs text-muted-foreground">From the player's saved purchase list. Restore purchase opens a mail draft with every recorded purchase attached for review.</p>
    {!entries.length ? <p className="text-sm text-muted-foreground">No purchased IAP recorded.</p> :
      <div className="space-y-2">{entries.map((entry) => <div key={entry.id} className="border-b border-border/50 pb-2 last:border-0">
        <div className="flex justify-between gap-3 text-sm"><code className="break-all">{entry.id}</code><span className="shrink-0">×{entry.amount}</span></div>
        <p className={`text-xs ${entry.issue ? "text-amber-300" : "text-muted-foreground"}`}>{entry.issue ?? entry.summary}</p>
      </div>)}</div>}
  </div>;
}
